import React, { useState, useContext } from "react";

import { Context } from "../../config/Context/AuthContext";

import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import Button from "@mui/material/Button";

import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import Link from "@mui/material/Link";

import styles from "./styles.module.css";

import logoAzul from "../../images/fenix_azul.png";

import {
  authenticationHandler,
  enviarTokenRedefinicaoDeSenha,
} from "../../services/auth.service";

import LockOpenIcon from "@mui/icons-material/LockOpen";

import MailOutlineIcon from "@mui/icons-material/MailOutline";

import { Dialog, DialogTitle, DialogContent, Grid } from "@mui/material";

import MensagemSucesso from "../../components/MensagemSucesso";
import MensagemErro from "../../components/MensagemErro";

import ResponsivContent from "../../components/ResponsivContent";
import { LoginContext } from "../../config/Context/LoginContext";

export const Login = () => {
  const [openModal, setOpenModal] = useState(false);
  const { dadosLogin, setDadosLogin } = useContext(LoginContext);

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const { signIn } = useContext(Context);

  const [user, setUser] = useState({
    login: "",
    senha: "",
  });

  const [status, setStatus] = useState({
    type: "",
    mensagem: "",
    loading: false,
  });

  const [msg, setMsg] = useState("");

  const valorInput = (e) =>
    setUser({ ...user, [e.target.name]: e.target.value });

  const loginSubmit = async (e) => {
    e.preventDefault();
    setStatus({
      loading: true,
    });

    authenticationHandler({
      login: user.login,
      senha: user.senha,
      sistema: "PTRIB",
    })
      .then(async (response) => {
        if (!response) {
          console.error("Resposta vazia recebida do serviço de autenticação");
          throw new Error("Resposta vazia");
        }
        
        // Para usuários internos/administrativos, usuarioPlanTrib pode não existir
        const usuarioPlanTrib = response.objRetorno.usuarioPlanTrib;
        const tipoCadastro = usuarioPlanTrib?.tipoCadastroPlanTrib || "I"; // Default "I" para internos
        const statusPlanTrib = usuarioPlanTrib?.statusPlanTrib || "APROVADO";
        
        setDadosLogin({
          ...dadosLogin,
          tipoCadastroPlanTribKey: tipoCadastro,
          status: statusPlanTrib,
          email: response.objRetorno.usuario.email,
          idUsuario: response.objRetorno.usuario.idUsuario,
          nome: response.objRetorno.usuario.nomeCompleto,
          funcionalidades: response.objRetorno.funcionalidades ?? []
        });
        signIn(response.objRetorno);
      })
      .catch((err) => {
        console.error("Erro no login:", err);
        if (err.response) {
          setStatus({
            type: "error",
            mensagem: err.response.data.mensagem,
            loading: false,
          });
        } else {
          setStatus({
            type: "error",
            mensagem: "Erro: tente mais tarde!",
            loading: false,
          });
        }
      });
  };

  const [email, setEmail] = useState("");

  const enviarTokenSenha = async (e) => {
    enviarTokenRedefinicaoDeSenha({ email })
      .then((response) => {
        setMsg(response.mensagem);
        handleOpenSnackbarSucesso();
      })
      .catch((err) => {
        if (err.response) {
          setMsg(err.response);
          handleOpenSnackbarErro();
        } else {
          setMsg("Por favor, tente novamente mais tarde.");
          handleOpenSnackbarErro();
        }
      });
  };

  const handleChangeEmail = (e) => {
    setEmail(e.target.value);
  };

  const [openSnackbarSucesso, setOpenSnackbarSucesso] = useState(false);
  const handleOpenSnackbarSucesso = () => {
    setOpenSnackbarSucesso(true);
  };

  const handleCloseSnackbarSucesso = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnackbarSucesso(false);
  };

  const [openSnackbarErro, setOpenSnackbarErro] = useState(false);
  const handleOpenSnackbarErro = () => {
    setOpenSnackbarErro(true);
  };

  const handleCloseSnackbarErro = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnackbarErro(false);
  };

  return (
    <div className={styles.main}>
      <ResponsivContent>
        <div className={styles.container}>
          <img className={styles.imgAltura} src={logoAzul} alt="Logo" />
        </div>
        <div className={styles.container}>
          <h2 className={styles.tituloLogin}>Login</h2>
        </div>
        <form onSubmit={loginSubmit}>
          <div>
            <label>E-mail: </label>
            <TextField
              fullWidth
              size="small"
              variant="outlined"
              onChange={valorInput}
              name="login"
              className={styles.loginTextField}
              autoComplete="username"
              inputProps={{ 'data-allow-special': 'true' }}
            />
          </div>

          <div className={styles.containerSenhaTextField}>
            <label>Senha: </label>
            <TextField
              className={styles.senhaTextField}
              fullWidth
              size="small"
              variant="outlined"
              type="password"
              onChange={valorInput}
              name="senha"
            />
          </div>
          {status.type === "error" ? (
            <p className={styles.mensagemUsuario}>{status.mensagem}</p>
          ) : (
            ""
          )}
          {status.type === "success" ? (
            <p className={styles.mensagemUsuario}>{status.mensagem}</p>
          ) : (
            ""
          )}
          {status.loading ? (
            <p className={styles.mensagemUsuario}>Carregando...</p>
          ) : (
            ""
          )}
          <Button
            type="submit"
            className={styles.botaoAcessar}
            variant="contained"
          >
            Entrar
          </Button>
          <div className={styles.container}>
            <Link
              href="/esqueci-minha-senha"
              className={styles.linkEsqueciSenha}
            >
              Esqueci Usuário/Senha
            </Link>
          </div>
        </form>
      </ResponsivContent>

      <Dialog
        open={openModal}
        onClose={handleCloseModal}
        PaperProps={{
          style: {
            width: "500px", // Defina a largura desejada
          },
        }}
        maxWidth="md" // Defina o tamanho máximo do modal
      >
        <DialogTitle>
          <div className={styles.tituloPopupContainer}>
            <LockOpenIcon className={styles.iconeTitulo} />
            <h1 className={styles.tituloPopup}>Redefinir senha</h1>
          </div>
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                fullWidth
                size="small"
                variant="outlined"
                type="email"
                placeholder="Digite o seu e-mail..."
                name="login"
                onChange={handleChangeEmail}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <div className={styles.fundoUsuario}>
                        <MailOutlineIcon className={styles.iconeUsuario} />
                      </div>
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            <Grid item xs={6}>
              <Button
                fullWidth
                className={styles.botaoPopupCancelar}
                onClick={handleCloseModal}
                size="small"
              >
                Cancelar
              </Button>
            </Grid>
            <Grid item xs={6}>
              <Button
                fullWidth
                className={styles.botaoPopupSalvar}
                onClick={enviarTokenSenha}
                color="primary"
                size="small"
              >
                Enviar
              </Button>
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>

      <MensagemSucesso
        open={openSnackbarSucesso}
        handleClose={handleCloseSnackbarSucesso}
        msg={msg}
      />

      <MensagemErro
        open={openSnackbarErro}
        handleClose={handleCloseSnackbarErro}
        msg={msg}
      />
    </div>
  );
};
